<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
        <div class="container-fluid">
            <span class="d-flex align-items-center">
                <router-link class="navbar-brand" to="/hoshitsuki">
                    <img src="@/hoshitsuki/assets/logo_hoshitsuki.png" class="logo" alt="ホシツキ">
                </router-link>
                <router-link to="/hoshitsuki" class="btn btn-sm btn-light"><i class="bi bi-house"></i>もどる</router-link>
            </span>

            <div class="justify-content-end">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <button @click="show_setting = true" class="btn btn-sm btn-info"><i class="bi bi-gear"></i></button>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="container-fluid container-full-height" :class="{'dark-mode': is_dark_mode}">

        <div class="wrap">
            <div class="frame">
                <div class="view">
                    <div class="board" :style="`transform: rotate(${rotate}deg)`">
                        <img src="@/hoshitsuki/assets/board-bg.png" alt="">
                        <img v-if="has_illust" src="@/hoshitsuki/assets/board-illust.svg" alt="">
                        <img v-if="has_line" src="@/hoshitsuki/assets/board-line.svg" alt="">
                        <!-- 星の明るさを表示 -->
                        <template v-if="has_brightness">
                            <!-- 等級選択で変更 -->
                            <img v-if="ShowStarsOption.keysShow1st().includes(show_stars)" src="@/hoshitsuki/assets/board-stars/board-star-1st.svg" alt="">
                            <img v-if="ShowStarsOption.keysShow2nd().includes(show_stars)" src="@/hoshitsuki/assets/board-stars/board-star-2nd.svg" alt="">
                            <img v-if="ShowStarsOption.keysShow3rd().includes(show_stars)" src="@/hoshitsuki/assets/board-stars/board-star-3rd.svg" alt="">
                            <img v-if="ShowStarsOption.keysShow4th().includes(show_stars)" src="@/hoshitsuki/assets/board-stars/board-star-4th.svg" alt="">
                            <img v-if="ShowStarsOption.keysShowAll().includes(show_stars)" src="@/hoshitsuki/assets/board-stars/board-star-others.svg" alt="">
                        </template>
                        <img v-else src="@/hoshitsuki/assets/board-stars/board-star-default.svg" alt="">
                        <part-star-labels :show_sign_label="has_sign_label" :show_star_label="has_star_label" @clickLabel="showDescription" />
                    </div>
                </div>
                <label class="direction-n">{{ $t('北') }}</label>
                <label class="direction-nw">{{ $t('北東') }}</label>
                <label class="direction-w">{{ $t('東') }}</label>
                <label class="direction-sw">{{ $t('南東') }}</label>
                <label class="direction-s">{{ $t('南') }}</label>
                <label class="direction-se">{{ $t('南西') }}</label>
                <label class="direction-e">{{ $t('西') }}</label>
                <label class="direction-ne">{{ $t('北西') }}</label>
            </div>
            <div class="control">
                <div class="control-area">
                    <button class="btn btn-sm btn-primary" @click="show_area = true"><i class="bi bi-pin-map-fill"></i> {{ area.label }}</button>
                </div>

                <div class="control-time">
                    <button @click="goHours(-1)" class="btn btn-sm btn-tiny btn-success"><small>1{{ $t('時間') }}</small><br><i class="bi bi-skip-start-fill"></i></button>
                    <span class="control-time-display" @click="show_time = true">
                        {{ month }}月{{ day }}日
                        {{ time }}
                        <i class="bi bi-clock"></i>
                    </span>
                    <button @click="goHours(1)" class="btn btn-sm btn-tiny btn-success"><small>1{{ $t('時間') }}</small><br><i class="bi bi-skip-end-fill"></i></button>
                </div>
            </div>
            <div class="reference">
                <button class="btn btn-sm btn-tiny btn-warning" @click="show_list = true"><i class="bi bi-book"></i><br><small>ホシツキ{{ $t('図鑑') }}</small></button>
            </div>
        </div>
    </div>

    <transition name="fade">
        <div v-if="show_setting">
            <div class="modal-backdrop show"></div>
            <div class="modal" tabindex="-1" style="display:block">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header py-1 bg-info">
                            <h4 class="modal-title">{{ $t('表示') }}{{ $t('設定') }}</h4>
                            <button type="button" class="btn-close" @click="show_setting = false"></button>
                        </div>
                        <div class="modal-body">
                            <form-checkbox
                                v-model="is_dark_mode"
                                :as_boolean="true"
                                :option_label="$t('夜') + 'モード'"
                            />
                            <form-checkbox
                                v-model="has_brightness"
                                :as_boolean="true"
                                :option_label="$t('星の明るさ') + 'を' + $t('表示')"
                            />
                            <div class="setting d-flex align-items-center" v-if="has_brightness">
                                <p class="fs-6 mb-0 ms-3 me-2 text-nowrap">見る{{ $t('星') }}の{{ $t('等級') }}</p>
                                <form-select
                                    v-model="show_stars"
                                    :options="show_stars_options"
                                />
                            </div>
                            <form-checkbox
                                v-model="has_illust"
                                :as_boolean="true"
                                :option_label="$t('星座') + 'のイラストを' + $t('表示')"
                            />
                            <form-checkbox
                                v-model="has_sign_label"
                                :as_boolean="true"
                                :option_label="$t('星座') + 'の' + $t('名前') + 'を' + $t('表示')"
                            />
                            <form-checkbox
                                v-model="has_star_label"
                                :as_boolean="true"
                                :option_label="$t('星') + 'の' + $t('名前') + 'を' + $t('表示')"
                            />
                            <form-checkbox
                                v-model="has_line"
                                :as_boolean="true"
                                :option_label="$t('星座') + 'の' + $t('線') + 'を' + $t('表示')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div v-if="show_area">
            <div class="modal-backdrop show"></div>
            <div class="modal" tabindex="-1" style="display:block">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header py-1 bg-primary text-white">
                            <h4 class="modal-title">{{ $t('地域') }}{{ $t('設定') }}</h4>
                            <button type="button" class="btn-close" @click="show_area = false"></button>
                        </div>
                        <div v-if="selected_region_id" class="p-3">
                            <div class="row">
                                <div class="col-md-8 mb-3" v-for="row of selected_region.areas" :key="row.label">
                                    <button class="btn btn-sm btn-outline-primary btn-full" @click="area = row; show_area = false">{{ row.label }}</button>
                                </div>
                                <div class="col-md-8 mb-3">
                                    <button class="btn btn-sm btn-outline-secondary btn-full" @click="selected_region_id = null">もどる</button>
                                </div>
                            </div>
                        </div>
                        <div v-else class="p-3">
                            <div class="row">
                                <div class="col-md-8 mb-3" v-for="region of regions" :key="region.id">
                                    <button class="btn btn-sm btn-outline-primary btn-full" @click="selected_region_id = region.id">{{ region.region_label }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div v-if="show_time">
            <div class="modal-backdrop show"></div>
            <div class="modal" tabindex="-1" style="display:block">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header py-1 bg-primary text-white">
                            <h4 class="modal-title">{{ $t('日時') }}{{ $t('設定') }}</h4>
                            <button type="button" class="btn-close" @click="show_time = false"></button>
                        </div>
                        <div class="modal-body">
                            <div class="text-center border rounded p-1 mb-2">
                                {{ month }}月{{ day }}日
                                {{ time }}
                            </div>
                            <div class="d-flex justify-content-between">
                                <button @click="goDays(-30)" class="btn btn-sm btn-tiny btn-success"><small>1ヶ月</small><br><i class="bi bi-skip-backward-fill"></i></button>
                                <button @click="goDays(-7)" class="btn btn-sm btn-tiny btn-success"><small>1{{ $t('週間') }}</small><br><i class="bi bi-skip-backward-fill"></i></button>
                                <button @click="goDays(-1)" class="btn btn-sm btn-tiny btn-success"><small>1日</small><br><i class="bi bi-skip-backward-fill"></i></button>
                                <button @click="goHours(-1)" class="btn btn-sm btn-tiny btn-success"><small>1{{ $t('時間') }}</small><br><i class="bi bi-skip-start-fill"></i></button>
                                <button @click="goNow()" class="btn btn-sm btn-tiny btn-outline-success"><small>{{ $t('現在') }}</small><br><i class="bi bi-clock"></i></button>
                                <button @click="goHours(1)" class="btn btn-sm btn-tiny btn-success"><small>1{{ $t('時間') }}</small><br><i class="bi bi-skip-end-fill"></i></button>
                                <button @click="goDays(1)" class="btn btn-sm btn-tiny btn-success"><small>1日</small><br><i class="bi bi-skip-forward-fill"></i></button>
                                <button @click="goDays(7)" class="btn btn-sm btn-tiny btn-success"><small>1{{ $t('週間') }}</small><br><i class="bi bi-skip-forward-fill"></i></button>
                                <button @click="goDays(30)" class="btn btn-sm btn-tiny btn-success"><small>1ヶ月</small><br><i class="bi bi-skip-forward-fill"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div v-if="show_list">
            <div class="modal-backdrop show"></div>
            <div class="modal" tabindex="-1" style="display:block">
                <div class="modal-dialog" style="max-width: 1020px;">
                    <div class="modal-content">
                        <div class="modal-header py-1 bg-secondary text-white">
                            <ul class="nav nav-tabs nav-pills border-0 py-2">
                                <li class="nav-item">
                                    <button @click="selected_list_category = 1" class="nav-link" :class="{'active': selected_list_category === 1}">{{ $t('星座') }}</button>
                                </li>
                                <li class="nav-item">
                                    <button @click="selected_list_category = 2" class="nav-link" :class="{'active': selected_list_category === 2}">{{ $t('星') }}</button>
                                </li>
                                <li class="nav-item">
                                    <button @click="selected_list_category = 3" class="nav-link" :class="{'active': selected_list_category === 3}">{{ $t('星雲') }}・{{ $t('その他') }}</button>
                                </li>
                            </ul>
                            <button type="button" class="btn-close" @click="show_list = false"></button>
                        </div>
                        <div class="modal-body">
                            <table class="table small">
                                <tbody>
                                    <tr v-for="row of filtered_descriptions" :key="row.code">
                                        <td class="w-25" v-if="row.category === 1">
                                            <figure class="sign-image">
                                                <img :src="`/hoshitsuki/images/sign-${row.code}.svg`" alt="">
                                            </figure>
                                        </td>
                                        <td>{{ descriptionLabel(row, grade) }}</td>
                                        <td><button class="btn btn-sm btn-primary" @click="showDescription(row.code)"><i class="bi bi-book"></i> せつめい</button></td>
                                        <td>
                                            <button
                                                v-if="$store.getters['hoshitsuki/found/has'](row.code)"
                                                @click="this.$store.commit('hoshitsuki/found/remove', row.code)"
                                                class="btn btn-sm btn-danger"
                                            ><i class="bi bi-star-fill"></i> 見つけ済</button>
                                            <button
                                                v-else
                                                @click="this.$store.commit('hoshitsuki/found/add', row.code)"
                                                class="btn btn-sm btn-info"
                                            ><i class="bi bi-star"></i> 見つけた！</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div v-if="description">
            <div class="modal-backdrop show" style="z-index:2050;"></div>
            <div class="modal" tabindex="-1" style="display:block; z-index:2055;">
                <div class="modal-dialog" style="max-width: 1020px;">
                    <div class="modal-content">
                        <div class="modal-header py-1 bg-secondary text-white">
                            <h4 class="modal-title">{{ descriptionLabel(description, grade) }}</h4>
                            <button type="button" class="btn-close" @click="description = false"></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-8" v-if="description.category === 1">
                                    <figure class="sign-image">
                                        <img :src="`/hoshitsuki/images/sign-${description.code}.svg`" alt="">
                                    </figure>
                                </div>
                                <div :class="{'col-16': description.category === 1, 'col-24': description.category !== 1}">
                                    <p>{{ descriptionPhrase(description, grade) }}</p>
                                    <div class="text-center">
                                        <button
                                            v-if="$store.getters['hoshitsuki/found/has'](description.code)"
                                            @click="this.$store.commit('hoshitsuki/found/remove', description.code)"
                                            class="btn btn-sm btn-danger"
                                        ><i class="bi bi-star-fill"></i> 見つけ済</button>
                                        <button
                                            v-else
                                            @click="this.$store.commit('hoshitsuki/found/add', description.code)"
                                            class="btn btn-sm btn-info"
                                        ><i class="bi bi-star"></i> 見つけた！</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

</template>

<script>

import ShowStarsOption from '@/shared/models/enums/hoshitsuki/show-stars-option';
import FormCheckbox from '@/shared/components/form/FormCheckbox';
import FormSelect from '@/shared/components/form/FormSelect';
import PartStarLabels from './parts/PartStarLabels';
import { Area, regions } from '../modules/area';
import { descriptions } from '../modules/descriptions';

export default {
    name: 'PageStar',
    components: {
        FormCheckbox,
        FormSelect,
        PartStarLabels,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
    ],
    data() {
        return {
            // 現在日時
            datetime: new Date(),
            // 学年
            grade: this.$store.state.hoshitsuki.auth.grade ?? 1,
            // 当年1月1日0時
            basetime: new Date((new Date()).getFullYear(), 0, 1, 0, 0, 0),
            // エリア
            area: new Area(null, null, 135),
            // エリア一覧
            regions,
            // 説明一覧
            descriptions,
            description_label: '', //モーダル
            description_phrase: '', //モーダル
            // 設定
            is_dark_mode: false,
            has_illust: true,
            has_line: true,
            has_star_label: true,
            has_sign_label: true,
            has_brightness: true,
            show_stars: ShowStarsOption.SHOW_ALL,
            // 選択肢
            show_stars_options: ShowStarsOption.options(this.$store.state.hoshitsuki.auth.grade ?? 1),
            // 画面制御
            show_setting: false,
            show_time: false,
            show_area: false,
            selected_region_id: null,
            show_list: false,
            selected_list_category: 1,
            description: null,
            //enum
            ShowStarsOption: ShowStarsOption,
        }
    },
    mounted() {
        this.setCurrentArea();
    },
    methods: {
        goHours(hours) {
            this.datetime = new Date(
                this.datetime.getFullYear(),
                this.datetime.getMonth(),
                this.datetime.getDate(),
                this.datetime.getHours() + hours,
                this.datetime.getMinutes(),
            );
        },
        goDays(days) {
            this.datetime = new Date(
                this.datetime.getFullYear(),
                this.datetime.getMonth(),
                this.datetime.getDate() + days,
                this.datetime.getHours(),
                this.datetime.getMinutes(),
            );
        },
        goNow() {
            this.datetime = new Date();
        },
        setCurrentArea() {
            // auth.school から該当エリアを取得
            for (let i = 0; i < this.regions.length; i++) {
                for (let k = 0; k < this.regions[i].areas.length; k++) {
                    if (this.regions[i].areas[k].code === this.$store.state.hoshitsuki.auth.school.pref) {
                        this.area = this.regions[i].areas[k];
                        break;
                    }
                }
            }
        },
        showDescription(value) {
            const found_description = this.descriptions.find(row => row.code === value);
            if (found_description !== undefined) {
                this.description = found_description;
            }
        },
        //[モーダル]星座の名前取得
        descriptionLabel(description, grade) {
            if (this.$helper.isNud(description) || this.$helper.isNud(grade)) {
                return '';
            }
            let label = description.label[grade];
            //小学生以外
            if (typeof label === 'undefined') {
                return description.label['default'];
            //小学生
            } else {
                return label;
            }
        },
        //[モーダル]星座の説明取得
        descriptionPhrase(description, grade) {
            if (this.$helper.isNud(description) || this.$helper.isNud(grade)) {
                return '';
            }
            let phrase = description.phrase[grade];
            //小学生以外
            if (typeof phrase === 'undefined') {
                return description.phrase['default'];
            //小学生
            } else {
                return phrase;
            }
        },
    },
    computed: {
        rotate() {
            const base_degree = 225;
            // 1月1日からの経過秒数
            const interval = this.datetime - this.basetime;
            const time_degree = (360 + (360 / 365)) * interval / (60 * 60 * 24 * 1000);
            // 軽度差 (TODO プラスマイナス要確認)
            const area_degree = 135 - this.area.longitude;
            return Math.floor(base_degree - time_degree + area_degree);
        },
        month() {
            return this.datetime.getMonth() + 1;
        },
        day() {
            return this.datetime.getDate();
        },
        hour() {
            return this.datetime.getHours();
        },
        minute() {
            return this.datetime.getMinutes();
        },
        time() {
            return this.hour.toString().padStart(2, '0') + ":" + this.minute.toString().padStart(2, '0');
        },
        selected_region() {
            if (this.selected_region_id === null) {
                return null;
            }

            return regions.filter((region) => region.id === this.selected_region_id)[0];
        },
        filtered_descriptions() {
            return this.descriptions.filter(row => row.category === this.selected_list_category);
        },
    }
}
</script>

<style scoped>
.container-full-height {width: 100%; height: calc(100vh - 2.875rem); padding: 0.3rem 0;}
.dark-mode {background: #001122;}
.wrap {position: relative; width: 100%; height: 100%;}
.frame {position: absolute; z-index: 0; top: 0; left: 0; right: 0; bottom: 0; margin: auto; max-width: calc(100% - 2rem); max-height: calc(100% - 2rem); aspect-ratio: 115 / 100;}
.frame::before {content: ""; position: absolute; z-index: 1; left: -0.5rem; top: -0.5rem; width: calc(100% + 1rem); height: calc(100% + 1rem); border-radius: 50%; background: var(--bs-warning);}
.frame::after {content: ""; position: absolute; z-index: 2; left: -0.1rem; top: -0.1rem; width: calc(100% + 0.2rem); height: calc(100% + 0.2rem); border-radius: 50%; background: #EEE;}
.view {position: relative; z-index: 4; width: 100%; height: 100%; background: #004488; border-radius: 50%; overflow: hidden;}
.board {position: absolute; left: -50%; right: -50%; bottom: 0; margin: auto; width: 130%; padding-bottom: 130%; transition: transform 0.5s;}
.board img,
.board svg {position: absolute; top: 0; left: 0; /* animation: spin 20s linear infinite; */}

.direction-n,
.direction-nw,
.direction-w,
.direction-sw,
.direction-s,
.direction-se,
.direction-e,
.direction-ne {position: absolute; z-index: 3; margin: auto; text-align: center; font-size: 0.5rem; line-height: 1rem; background: var(--bs-info); color: #FFF; border-radius: 50%;}

.direction-n {top: -1.1rem;/*-1rem*/ left: 0; right: 0; width: 2rem;/*1rem*/ height: 1rem;}
.direction-nw {top: 2.8%;/*1.5%*/ left: 15%;/*21%*/ width: 2.5rem;/*1.5rem*/ height: 1rem; transform: rotate(-30deg);}
.direction-w {top: 20%; left: 0;/*3%*/ width: 2rem;/*1rem*/ height: 1rem; transform: rotate(-55deg);}
.direction-sw {top: 0; bottom: 0; left: -1.8rem;/*-1.2rem*/ width: 2.5rem;/*1.5rem*/ height: 1rem; transform: rotate(-90deg);}
.direction-s {bottom: -1.1rem;/*-1rem*/ left: 0; right: 0; width: 2rem;/*1rem*/ height: 1rem; transform: rotate(180deg);}
.direction-se {top: 0; bottom: 0; right: -1.8rem;/*-1.2rem*/ width: 2.5rem;/*1.5rem*/ height: 1rem; transform: rotate(90deg);}
.direction-e {top: 20%; right: 0;/*3%*/ width: 2rem;/*1rem*/ height: 1rem; transform: rotate(55deg);}
.direction-ne {top: 2.8%;/*1.5%*/ right: 15%;/*21%*/ width: 2.5rem;/*1.5rem*/ height: 1rem; transform: rotate(30deg);}

.control {position: absolute; z-index: 5; bottom: 0; left: 0; width: 100%; padding: 0 10px; display: flex; flex-wrap: wrap; justify-content: space-between;}
@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}
.control-area {width: 200px;}
.control-area .btn {width: 100%;}
.control-time {width: 100%; max-width: 450px; display: flex; align-items: center; background: #FFF; border-radius: 0.2rem;}
.control-time-display {flex-grow: 1; text-align: center;}

.btn-full {width: 100%;}
.btn-tiny {padding: 0.05rem 0.4rem; line-height: 1;}
.btn-tiny small {font-size: 0.5rem;}

.reference {
    position: absolute; z-index: 5; top: 0; right: 0; padding: 0 10px;
}

.sign-image {position: relative; width: 100%; height: 0; margin-bottom: 0; padding-top: 100%; background: #004488;}
.sign-image img {position: absolute; left: 5%; top: 5%; width: 90%; height: 90%; object-fit: contain;}
</style>
